module.exports = __webpack_public_path__ + "static/media/1f939-1f3fd.df760d5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f939-1f3fd.svg
// module id = 630
// module chunks = 1